<template>
  <button
    class="border px-4 sm:px-6 rounded-3xl lg:leading-none"
    :class="{
      'text-sm font-medium border-solid border-app-primary-1-red--fire-brick bg-app-primary-1-red--fire-brick text-white': state === 'active',
      'text-sm font-medium border-solid border-app-primary-1-red--fire-brick bg-app-primary-grey--black-squeeze text-app-primary-1-red--fire-brick hover:bg-app-primary-1-red--fire-brick hover:text-white transition duration-300 ease-in-out':
        state === 'available' && !mobile,
      'text-sm font-medium border-solid border-app-primary-1-red--fire-brick bg-white': state === 'available' && mobile,
      'text-sm font-medium border-none bg-white text-app-primary-grey--concrete pointer-events-none': state === 'unavailable',
      'text-xs lg:text-sm font-semibold text-app-primary-1-red--fire-brick border-app-primary-1-red--fire-brick lg:border-none lg:text-black lg:bg-app-primary-grey--black-squeeze rounded-3xl':
        state === 'neutral',
      'text-sm font-medium border-none bg-app-primary-1-orange--bittersweet text-white rounded-3xl': state === 'results',
      'py-2': mobile === false,
      'py-1': mobile === true,
    }"
  >
    <slot />
  </button>
</template>

<script setup lang="ts">
defineProps({
  /**
   * We have various states:
   *
   * active
   * available (1)
   * available mobile (2)
   * unavailable
   * neutral
   * results
   *
   * This button is exclusively used for filters
   */
  state: { type: String, required: false, default: 'available', validator: (value: string) => ['active', 'available', 'unavailable', 'neutral', 'results'].includes(value) },
  mobile: { type: Boolean, required: false, default: false },
})
</script>
